export default __webpack_public_path__ + "static/media/location_preview_music_shop.2335aa13.svg";